import useQuery, { QueryOptions } from "../common/lib/fetch/useQuery";

export interface DevSiteSettingsDto {
  scales: Array<{ id: string; name: string; }>;
  bays: Array<{ id: string; name: string; }>;
}

export const useGetDevSiteSettings = (siteId: string, options?: QueryOptions<DevSiteSettingsDto>) => 
  useQuery<DevSiteSettingsDto>({
    headers: () => Promise.resolve(new Headers()),
    path: `/api/developer/sites/${siteId}/settingsDev`,
  }, options);